import React from 'react';
import PropTypes from 'prop-types';
import {prune} from 'underscore.string';
import classNames from 'classnames';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

export default class CustomButtonDropdown extends React.Component {

  static propTypes = {
    caretImg: PropTypes.string,
    children: PropTypes.any.isRequired,
    className: PropTypes.string,
    displayTextMaxLength: PropTypes.number,
    hideLabelOnMobile: PropTypes.bool,
    noDisplayText: PropTypes.bool,
    onSelect: PropTypes.func,
    positionLeft: PropTypes.bool,
    pullLeft: PropTypes.bool,
    showActive: PropTypes.bool,
    noButton: PropTypes.bool,
    text: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.string,
    color: PropTypes.string,
  }

  static defaultProps = {
    color: 'secondary',
    displayTextMaxLength: 1000,
    hideLabelOnMobile: false,
    onSelect: () => {},
    pullLeft: false,
    showActive: true,
    text: '',
    type: 'blank',
    noButton: false,
    caret: true,
    size: 'md',
  }

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      value: this.props.value || null,
    };
  }

  /**
   * Return a string to display as the button text
   */
  getDisplayText = () => {
    if (this.props.noDisplayText) {
      return '';
    }

    var fullString = this.props.showActive
      ? this.state.displayText || this.seekDisplayText(this.props.children, this.state.value) || this.props.text
      : this.props.text;

    return prune(fullString, this.props.displayTextMaxLength);
  }

  seekDisplayText = (children, selectedValue) => {
    const selected = children
      .filter(child => !!child)
      .find(child => child.props.val === selectedValue);

    if (!selected) {
      return;
    }

    return selected.props.displayText || selected.props.children || selectedValue;
  }

  /**
   * When dropdown button is clicked
   */
  onClick = (event) => {
    // Toggle open state
    this.setState({
      open: !this.state.open,
    });

    event.stopPropagation();
  }

  /**
   * When a child item is selected
   */
  onItemSelect = (value, displayText) => {
    const text = this.props.noDisplayText ? '' : displayText;

    this.setState({
      value: value,
      displayText: text,
      open: false,
    });

    this.props.onSelect(value, text);
  }

  render() {
    const {caretImg, caret, size, children, buttonClass, className, color, hideLabelOnMobile, noButton, pullLeft, type} = this.props;

    const dropdownStyles = this.props.positionLeft ? {left: '-93px'} : null;

    const labelClasses = {
      'hidden-xs': hideLabelOnMobile,
    };

    return (
      <ButtonDropdown
        className={className}
        isOpen={this.state.open}
        toggle={this.onClick}
      >
        <DropdownToggle
          caret={caret}
          color={color}
          size={size}
        >
          <span className={classNames(labelClasses)}>
            {this.getDisplayText()}
          </span>
        </DropdownToggle>
        <DropdownMenu>
          {children}
        </DropdownMenu>
      </ButtonDropdown>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/buttons/buttonDropdown/buttonDropdown.js